import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=a1f20e10&scoped=true"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=a1f20e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f20e10",
  null
  
)

export default component.exports